import client from "./client";

export const getOrders = ({
  id,
  page,
  size,
  ordering,
  name,
  phone,
  email,
  orderNumber,
  invoiceNumber,
  status,
  startCreatedDate,
  endCreatedDate,
  userName,
  userPhone,
  userEmail,
  productName,
  optionName,
}) =>
  client.get(`/order/`, {
    params: {
      id,
      page,
      size,
      ordering,
      name,
      phone,
      email,
      orderNumber,
      invoiceNumber,
      status,
      startCreatedDate,
      endCreatedDate,
      userName,
      userPhone,
      userEmail,
      productName,
      optionName,
    },
  });

export const getInvoiceHistories = (params) =>
  client.get(`/invoice-excel-history/`, params);

export const editOrder = (params) =>
  client.put(`/order/${params?.id}/`, params);

export const saveOrderMemo = (params) =>
  client.post(`/order-memo/`, params);

export const editOrderMemo = (params) =>
  client.put(`/order-memo/${params?.id}/`, params);

export const editOrderProduct = (params) =>
  client.put(`/order-product/${params?.id}/`, params);

export const getExcelFields = (params) =>
  client.get(`/excel-field/`, { params });

export const getExcelFormats = (params) =>
  client.get(`/excel-format/`, { params });

export const createExcelFormat = (params) =>
  client.post(`/excel-format/`, params);

export const getExcelFormat = ({ id }) => client.get(`/excel-format/${id}/`);

export const editExcelFormat = (params) =>
  client.put(`/excel-format/${params.id}/`, params);

export const deleteExcelFormat = ({ id }) =>
  client.delete(`/excel-format/${id}/`);

export const getPointHistories = (params) =>
  client.get(`/point-history/`, { params });

export const createPointHistory = (params) =>
  client.post(`/point-history/`, params );
